import React from 'react';

import PropTypes from 'prop-types';

import { Container } from './styles';

export const PromoBadge = (props) => {
    return (
        <Container
            isInactive={props.isInactive}
            isSelected={props.isSelected}
            isDisabled={props.isDisabled}
            onClick={props.onClick}
            onKeyPress={props.onClick}
            tabIndex={'0'}
        >
            {props.caption}
        </Container>
    );
};

PromoBadge.propTypes = {
    caption: PropTypes.string,
    isInactive: PropTypes.bool,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
};
